import gatewayAuthBuilders from "./gatewayAuthBuilders";

export const buildGatewayAuth = ({
  type,
  formValues,
  savedgateway,
}: any) => {
  const builder = gatewayAuthBuilders[type];
  if (!builder) return undefined;

  return builder({
    formValues,
    saved: savedgateway?.[0],
  });
};